const TOKEN_KEY = 'auth_token';

/** Adjunta access_token a URLs /uploads para <img src> tras proteger el static. */
export const appendUploadAccessToken = url => {
    if (!url || typeof url !== 'string') {
        return url;
    }

    if (/^(blob:|data:)/i.test(url)) {
        return url;
    }

    if (!url.includes('/uploads/') && !url.includes('/api/uploads/')) {
        return url;
    }

    let token = null;
    try {
        token = localStorage.getItem(TOKEN_KEY);
    } catch {
        token = null;
    }

    if (!token) {
        return url;
    }

    try {
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('access_token', token);
        if (url.startsWith('/') && !/^https?:\/\//i.test(url)) {
            return `${parsed.pathname}${parsed.search}${parsed.hash}`;
        }
        return parsed.toString();
    } catch {
        const sep = url.includes('?') ? '&' : '?';
        return `${url}${sep}access_token=${encodeURIComponent(token)}`;
    }
};
